import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BudgetTableContainer } from 'pages/calculator/MediaPlanning/common/BudgetTable/styles';
import BudgetTableRow from 'pages/calculator/MediaPlanning/common/BudgetTable/DigitalBudgetTable/BudgetTableRow/BudgetTableRow';
import {
  DigitalBudgetTableRowData,
  TableHeader,
} from 'pages/calculator/MediaPlanning/common/BudgetTable/interfaces';
import calculateDigitalTotalBudgetRowData from 'pages/calculator/MediaPlanning/common/BudgetTable/utils/calculateDigitalTotalBudgetRowData';

interface DigitalBudgetTableProps {
  data: DigitalBudgetTableRowData[];
}

function DigitalBudgetTable({ data }: DigitalBudgetTableProps) {
  const { t } = useTranslation();

  const tableHeaders: TableHeader[] = [
    { key: 'mediaPlanning.touchpoint', align: 'left', width: '200px' },
    { key: '', align: 'left' },
    { key: 'mediaPlanning.impressions', align: 'right' },
    { key: 'mediaPlanning.reach', align: 'right' },
    { key: 'mediaPlanning.clicks', align: 'right' },
    { key: 'mediaPlanning.videoViews', align: 'right' },
    { key: 'mediaPlanning.budget', align: 'right' },
  ];

  if (!data.length) {
    return null;
  }

  return (
    <Grid container sx={{ px: '15px' }}>
      <Grid item xs={12}>
        <Typography
          textTransform="uppercase"
          fontWeight={700}
          sx={{ pb: '12px' }}
        >
          {t('mediaPlanning.digitalBudget')}
        </Typography>
        <BudgetTableContainer>
          <Table sx={{ tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '34px' }} />
                {tableHeaders.map((header) => (
                  <TableCell
                    key={header.key}
                    align={header.align}
                    sx={{ width: header?.width || 'auto' }}
                  >
                    <Typography
                      variant="caption"
                      textTransform="uppercase"
                      fontWeight={600}
                    >
                      {t(header.key)}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <BudgetTableRow
                  key={row.touchpointName + String(index)}
                  rowData={row}
                />
              ))}
              <BudgetTableRow
                rowData={calculateDigitalTotalBudgetRowData(data)}
                sx={{ backgroundColor: 'tableBackground.main' }}
                isTotalBudgetRow
              />
            </TableBody>
          </Table>
        </BudgetTableContainer>
      </Grid>
    </Grid>
  );
}

export default DigitalBudgetTable;
